import * as React from 'react';

type FunctionalChild<T> = (value: T) => React.ReactNode;
export type PropsWithOptionalFunctionalChildren<P = unknown, T = unknown> = P & {
  children?: React.ReactNode | FunctionalChild<T>;
};

export const getChildren = <T>(children: FunctionalChild<T> | React.ReactNode, value: T) => {
  if (typeof children === 'function') {
    return children(value);
  }

  return children;
};
